<!-- QuickBuild Dropdown Menu Content -->
  <div
    class="tw-px-3 tw-py-1 tw-min-w-[36rem]"
    [ngClass]="{'!tw-p-0 !tw-min-w-0': embedded}"
    (click)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()">
    <div
      *ngIf="!embedded"
      class="tw-flex tw-justify-between tw-items-center tw-px-1 xl:tw-px-2 tw-pb-3 tw-border-0 tw-border-solid tw-border-b tw-border-gray-300 dark:tw-border-gray-600">
      <div class="tw-flex tw-items-center">
        <div class="tw-text-base tw-font-medium tw-text-gray-800 dark:tw-text-gray-200">
          <span>Load a Quick Build</span>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <button mat-button color="primary" (click)="onViewAll()">Browse All</button>
      </div>
    </div>

    <div [ngClass]="{'tw-mt-4': !embedded}">
      <!-- Show both columns when there are recent quickbuilds -->
      <div *ngIf="recentlyUsedQuickBuilds.length > 0" class="tw-grid tw-grid-cols-2 tw-gap-x-6">
        <!-- Recent QuickBuilds Column -->
        <div class="tw-col-span-1">
          <h3 class="tw-text-base tw-font-semibold tw-text-gray-800 dark:tw-text-gray-200 tw-mb-3 tw-px-1">Recent</h3>
          <div class="tw-space-y-3">
            <app-quick-build-item-renderer
              class="tw-block tw-mb-3 tw-max-w-[365px]"
              *ngFor="let quickbuild of recentlyUsedQuickBuilds; trackBy: trackByQuickBuildId"
              [item]="quickbuild"
              [showCreator]="false"
              [allowDelete]="false"
              (itemSelected)="onSelectionChange($event.id)">
            </app-quick-build-item-renderer>
          </div>
        </div>

        <!-- Popular QuickBuilds Column -->
        <div class="tw-col-span-1">
          <h3 class="tw-text-base tw-font-semibold tw-text-gray-800 dark:tw-text-gray-200 tw-mb-3 tw-px-1">Popular</h3>
          <div class="tw-space-y-3">
            <ng-container *ngIf="quickBuildsLoaded; else loadingPopularQuickBuilds">
              <ng-container *ngIf="popularQuickBuilds.length > 0; else noPopularQuickBuilds">
                <app-quick-build-item-renderer
                  class="tw-block tw-mb-3 tw-max-w-[365px]"
                  *ngFor="let quickbuild of popularQuickBuilds; trackBy: trackByQuickBuildId"
                  [item]="quickbuild"
                  [showCreator]="false"
                  [allowDelete]="false"
                  (itemSelected)="onSelectionChange($event.id)">
                </app-quick-build-item-renderer>
              </ng-container>
              <ng-template #noPopularQuickBuilds>
                <div class="tw-text-gray-500 tw-text-sm tw-px-1 tw-py-2">
                  No popular quick builds available
                </div>
              </ng-template>
            </ng-container>
            <ng-template #loadingPopularQuickBuilds>
              <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
                <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Show only popular quickbuilds in 2 columns when no recent quickbuilds -->
      <div *ngIf="recentlyUsedQuickBuilds.length === 0">
        <h3 class="tw-text-base tw-font-semibold tw-text-gray-800 dark:tw-text-gray-200 tw-mb-3 tw-px-1">Popular</h3>
        <div class="tw-grid tw-grid-cols-2 tw-gap-x-6">
          <div class="tw-col-span-1">
            <div class="tw-space-y-3">
              <ng-container *ngIf="quickBuildsLoaded; else loadingFirstColumn">
                <app-quick-build-item-renderer
                  class="tw-block tw-mb-3 tw-max-w-[365px]"
                  *ngFor="let quickbuild of popularQuickBuildsFirstColumn; trackBy: trackByQuickBuildId"
                  [item]="quickbuild"
                  [showCreator]="false"
                  [allowDelete]="false"
                  (itemSelected)="onSelectionChange($event.id)">
                </app-quick-build-item-renderer>
              </ng-container>
              <ng-template #loadingFirstColumn>
                <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
                  <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="tw-col-span-1">
            <div class="tw-space-y-3">
              <ng-container *ngIf="quickBuildsLoaded; else loadingSecondColumn">
                <app-quick-build-item-renderer
                  class="tw-block tw-mb-3 tw-max-w-[365px]"
                  *ngFor="let quickbuild of popularQuickBuildsSecondColumn; trackBy: trackByQuickBuildId"
                  [item]="quickbuild"
                  [showCreator]="false"
                  [allowDelete]="false"
                  (itemSelected)="onSelectionChange($event.id)">
                </app-quick-build-item-renderer>
              </ng-container>
              <ng-template #loadingSecondColumn>
                <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
                  <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div
          *ngIf="quickBuildsLoaded && popularQuickBuildsFirstColumn.length === 0"
          class="tw-text-gray-600 dark:tw-text-gray-500 tw-text-sm tw-px-1 tw-py-2">
          No popular quick builds available
        </div>
      </div>
      
      <!-- Browse All button in embedded mode - appears at the bottom regardless of recent items -->
      <div *ngIf="embedded" class="tw-text-center tw-mt-4">
        <button mat-button color="primary" (click)="onViewAll()">Browse All</button>
      </div>
    </div>
  </div>